/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerCheckEntitlementQueryResponse, OrganizationsControllerCheckEntitlementPathParams } from "../../models/organizationsController/OrganizationsControllerCheckEntitlement";

function getOrganizationsControllerCheckEntitlementUrl(id: OrganizationsControllerCheckEntitlementPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/organizations/${id}/entitlement` as const }  
  return res
}

/**
 * @summary Check organization Trimble EMS entitlement.
 * {@link /api/v1/organizations/:id/entitlement}
 */
export async function organizationsControllerCheckEntitlement(id: OrganizationsControllerCheckEntitlementPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OrganizationsControllerCheckEntitlementQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getOrganizationsControllerCheckEntitlementUrl(id).url.toString(), ... requestConfig })  
  return res.data
}